import dictionary from "../langs.json";

export enum ResourceTypeEnum {
  Presentation = 0,
  Video,
  MaterialForStudent,
  Scenario,
}

export let isResourceType = (
  variable: unknown
): variable is ResourceTypeEnum => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "number" &&
    variable in ResourceTypeEnum
  );
};

export const allResourceTypes: ResourceTypeEnum[] = [
  ResourceTypeEnum.Presentation,
  ResourceTypeEnum.Video,
  ResourceTypeEnum.MaterialForStudent,
  ResourceTypeEnum.Scenario,
];

export function getResourceTypeString(resourceTypeId: ResourceTypeEnum) {
  return dictionary.ru.translation[
    ("resourceType" + resourceTypeId) as keyof typeof dictionary.ru.translation
  ];
}
